import { Link } from 'react-router-dom';
import { User } from 'firebase/auth';

import { Toolbar, IconButton, Stack } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';

import BackupLink from '../../backup/BackupLink';
import {
  AppBarRoot,
  SidebarToggleButton,
  AccountAvatar,
} from '../../../styled/Sidebar.styled';
import Logo from '../../Logo';

interface AppBarProps {
  sidebarOpen: boolean;
  currentUser: User | null;
  onSidebarOpen: () => void;
  onSignOut: () => void;
}

const AppBar = ({
  sidebarOpen,
  currentUser,
  onSidebarOpen,
  onSignOut,
}: AppBarProps) => {
  const isAuthenticated = !!currentUser;
  return (
    <AppBarRoot position="fixed" open={sidebarOpen}>
      <Toolbar>
        {isAuthenticated && (
          <SidebarToggleButton
            color="inherit"
            onClick={onSidebarOpen}
            edge="start"
          >
            <MenuIcon />
          </SidebarToggleButton>
        )}
        <Logo />
        <Stack flexDirection="row" marginLeft="auto" gap={1}>
          <Link to={isAuthenticated ? '/account' : '/login'}>
            <IconButton>
              {isAuthenticated ? <AccountAvatar /> : <AccountCircleIcon />}
            </IconButton>
          </Link>
          {isAuthenticated && (
            <>
              <Link to="/dashboard">
                <IconButton>
                  <DashboardIcon />
                </IconButton>
              </Link>
              <BackupLink currentUser={currentUser} />
              <IconButton color="primary" onClick={onSignOut}>
                <LogoutIcon />
              </IconButton>
            </>
          )}
        </Stack>
      </Toolbar>
    </AppBarRoot>
  );
};

export default AppBar;
